import { queriesPayrollRuns } from "@query";
import { WSAlert } from "@wingspanhq/fe-component-library";
import { PayrollRunType } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { PAYROLL_RUNS_IN_FLIGHT_STATUSES } from "../../PayrollRuns/constants";

/**
 * Whether a contractor payroll run has money in flight right now.
 *
 * Replaces the v1 check, which asked the same question of bulk payroll batches
 * (`filter[status][in]=Pending,Processing`) because a v1 run *was* a batch.
 */
export const useHasContractorPayrollRunInFlight = () => {
  const query = queriesPayrollRuns.listPayrollRuns.useQuery({
    filter: {
      type: { eq: PayrollRunType.CONTRACTOR_VENDOR },
      status: { anyOf: PAYROLL_RUNS_IN_FLIGHT_STATUSES }
    },
    page: { size: 1 }
  });

  return !!query.data?.data?.length;
};

export const AlertContractorPayrollRunInProgress: React.FC = () => {
  if (!useHasContractorPayrollRunInFlight()) {
    return null;
  }

  return (
    <WSAlert theme="info" title="A payroll run is already in progress">
      A payroll run is already in progress (scheduled or off-cycle). Once the
      progress is complete, a new off-cycle payroll run can be initiated.
    </WSAlert>
  );
};
